import React, { useState, useEffect, memo } from "react"
import { useStore } from "../../teafuljs/store"
import { navigate } from "gatsby"
import { makeStyles } from "@material-ui/styles"
import IconButton from "@material-ui/core/IconButton"
import PlayCircleFilled from "@material-ui/icons/PlayCircleFilled"
import SegmentTitles from "../../data/SegmentTitles.json"
import { matches, viewport, addMatch } from "../../scripts/getCurrentRef"
import { getTranslation } from "../../scripts/getTranslation"
import TimePeriod from "../../data/StandardTimePeriodData.json"
import ChronologicalTP from "../../data/ChronologicalTimePeriods.json"
import { recordEvent } from "../../apis/googleAnalytics"
import getStandardVerse from "../../scripts/getStandardVerse"

const useStyles = makeStyles(theme => ({
  link: {
    position: "fixed",
    bottom: "0.3em",
    paddingTop: "0em",
    paddingBottom: "0.14em",
  },
  left: {
    left: "0.3em",
    paddingLeft: "0.13em",
    paddingRight: "0.17em",
    zIndex: 1000,
  },
  right: {
    right: "0.3em",
    paddingLeft: "0.17em",
    paddingRight: "0.13em",
    zIndex: 1000,
  },
  icon: {
    backgroundColor: "white",
    color: "#3A4C7D",
    borderRadius: "25px",
    fontSize: "40px",
  },
  currentRefContainer: {
    left: 0,
    right: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: 15,
    zIndex: 100,
  },
  containerHolder: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  currentRef: {
    borderRadius: "15px",
    width: "fit-content",
    padding: "0px 10px",
    fontSize: "65%",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    textAlign: "center",
    border: "white solid 3px",
  },
  currentTimePeriod: {
    borderRadius: "15px",
    width: "fit-content",
    padding: "4px 10px",
    fontSize: "65%",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    textAlign: "center",
    border: "white solid 3px",
    maxWidth: "60vw",
    marginTop: 5,
    lineHeight: 1.1,
  },
}))

const IconButtons = memo(props => {
  const classes = useStyles()
  const [history, setHistory] = useStore.history();
  const [currentBook, setCurrentBook] = useStore.currentBook()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [refID, setRefID] = useStore.refID();
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0];
  const version = useStore.version()[0];
  const translations = useStore.translations()[0];
  const showCurrentRef = useStore.showCurrentRef()[0]
  const showTimePeriod = useStore.showTimePeriod()[0]
  const segmentOrder = useStore.segmentOrder()[0]
  const versification = useStore.versification()[0]
  const interlinear = useStore.interlinear()[0]
  const showSpheres = useStore.showSpheres()[0]
  const showValues = useStore.showValues()[0]
  const showVerbs = useStore.showVerbs()[0]
  const [currentRefLocation, setCurrentRefLocation] = useState(null)

  var blocks = []
  var blockHeight
  var blocksNumber

  useEffect(() => {
    setTimeout(() => {
      blocks = []
      blockHeight = null
      blocksNumber = null
      onWindowLoad()
    }, 1000)
  }, [
    currentSegmentID,
    showCurrentRef,
    showTimePeriod,
    language,
    version,
  ])
  // ------------------------------------------------- //
  // --------- CURRENT REF LOCATION SCRIPT ----------- //
  // ------------------------------------------------- //

  function addElement(element) {
    /* This works fine if the rest of the nodes stayed in the
     * same position with the same size when element was added.
     */
    if (!element.getBoundingClientRect) return
    var rect = element.getBoundingClientRect()
    var y = rect.top + window.pageYOffset
    var y2 = y + element.offsetHeight
    var from = Math.trunc(y / blockHeight)
    var to = Math.trunc(y2 / blockHeight)

    for (var b = from; b <= to; ++b) {
      if (b < 0) {
        blocks[0].push(element)
      } else if (blocks[b]) {
        blocks[b].push(element)
      }
    }
    var nodes = element.childNodes
    if (nodes) {
      for (var i = 0; i < nodes.length; ++i) {
        addElement(nodes[i])
      }
    }
  }

  function onWindowScroll() {
    var vp = new viewport()
    var from = Math.trunc(vp.y / blockHeight)
    var to = Math.trunc(vp.y2 / blockHeight)
    var array = []
    for (var b = from; b <= to; ++b) {
      if (blocks[b]) {
        var block = blocks[b]
        for (var i = 0; i < block.length; ++i) {
          if (matches(block[i], vp)) {
            addMatch(block[i], array)
          }
        }
      }
    }
    if (array.length > 0) {
      const verseRef = array[0].getAttribute("verseref")
      const refIDSplit = verseRef.split("-")
      const standardRef = versification
        ? getStandardVerse(
            versification[version],
            `${refIDSplit[1]}-${refIDSplit[2]}-${refIDSplit[3]}`
          ).split("-")
        : `${refIDSplit[1]}-${refIDSplit[2]}-${refIDSplit[3]}`.split("-")

      const refString = `${getTranslation(
        translations,
        language,
        "Books",
        `abbrev_${refIDSplit[1]}`
      )} ${refIDSplit[2]}:${refIDSplit[3]}`
      setCurrentRefLocation({
        eng: `${standardRef[0]} ${standardRef[1]}:${standardRef[2]}`,
        translation: refString,
      })
    } else {
      setCurrentRefLocation(null)
    }
  }

  function onWindowLoad() {
    setTimeout(function() {
      /* Now we create the blocks */
      var nodes = document.body.childNodes
      blockHeight = window.innerHeight
      blocksNumber = Math.ceil(document.body.offsetHeight / blockHeight)
      for (var b = 0; b < blocksNumber; ++b) {
        blocks[b] = []
      }
      /* And we add all the nodes into they corresponding blocks */
      for (var i = 0; i < nodes.length; ++i) {
        addElement(nodes[i])
      }
      window.addEventListener("scroll", onWindowScroll, false)
      onWindowScroll() // Initialize
    }, 20)
  }

  // ------------------------------------------------- //
  // ------- END CURRENT REF LOCATION SCRIPT --------- //
  // ------------------------------------------------- //

  // This set of code sets the links for the previous and next buttons of the navigation
  const checkSegmentExists = (segmentID, direction) => {
    const books = Object.keys(
      AvailableContent.content[language][version]
    )
    let exists = false
    if (
      (segmentID !== undefined && direction !== "prev") ||
      (segmentID !== undefined && direction !== "next")
    ) {
      books.forEach(book => {
        if (
          AvailableContent.content[language][version][
            book
          ].segments.indexOf(segmentID) !== -1
        ) {
          exists = book
        }
      })
      return exists
    } else {
      return "home"
    }
  }

  const getAvailableTimePeriods = (language, version) => {
    let availableSegments = []
    const availableBooks = Object.keys(
      AvailableContent.content[language][version]
    )
    availableBooks.forEach(book => {
      availableSegments = [
        ...availableSegments,
        ...AvailableContent.content[language][version][book].segments,
      ]
    })

    let availableTP = {}
    const allTimePeriods = Object.keys(ChronologicalTP)
    allTimePeriods.forEach(TimeP => {
      ChronologicalTP[TimeP].forEach(seg => {
        if (availableSegments.indexOf(seg) !== -1) {
          if (availableTP[TimeP]) {
            availableTP[TimeP].push(seg)
          } else {
            availableTP[TimeP] = [seg]
          }
        }
      })
    })

    return availableTP
  }

  const checkNavSegmentExists = (currentSeg, direction) => {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
    ...history])

    if (segmentOrder === "Bible") {
      const segmentIDs = Object.keys(SegmentTitles)
      const index = segmentIDs.indexOf(currentSeg)
      let i = direction === "prev" ? -1 : 1
      while (!checkSegmentExists(segmentIDs[index + i], direction)) {
        if (direction === "prev") {
          i = i - 1
        } else {
          i = i + 1
        }
      }
      if (checkSegmentExists(segmentIDs[index + i], direction) === "home") {
        recordEvent(
          "Bottom Button Navigation",
          `${language}-${version}`,
          `HOME`
        )
        navigate(`/`, {
          state: {
            currentInterlinear: interlinear,
            currentShowSpheres: showSpheres,
            currentShowVerbs: showVerbs,
            currentShowValues: showValues,
          },
        })
      } else {
        const newSegmentID = segmentIDs[index + i]
        const newBook = checkSegmentExists(segmentIDs[index + i])
        setCurrentBook(newBook)

        recordEvent(
          "Bottom Button Navigation",
          `${language}-${version}`,
          newSegmentID
        )
        setCurrentSegmentID(newSegmentID)
        setRefID('Top')
      }
    } else {
      const availableSegmentsData = getAvailableTimePeriods(
        language,
        version
      )
      const TPs = Object.keys(availableSegmentsData)
      let segmentOrderArray = []
      TPs.forEach(
        tp =>
          (segmentOrderArray = [
            ...segmentOrderArray,
            ...availableSegmentsData[tp],
          ])
      )
      const index = segmentOrderArray.indexOf(currentSeg)
      const newIndex = direction === "prev" ? index - 1 : index + 1
      const newBook = checkSegmentExists(segmentOrderArray[newIndex])
      setCurrentBook(newBook)

      recordEvent(
        "Bottom Button Navigation",
        `${language}-${version}`,
        segmentOrderArray[newIndex]
      )
      setCurrentSegmentID(segmentOrderArray[newIndex])
      setRefID("Top")
    }
  }

  function hasUnicode(str) {
    for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127) {
        return str.charCodeAt(i)
      }
    }
    return false
  }

  function getTimePeriodText(array) {
    if (!Array.isArray(array)) {
      return ""
    }
    if (array.length === 1) {
      const character = String.fromCharCode(hasUnicode(array[0]))
      const reformatted = array[0].split(character).join(" ")
      return getTranslation(
        translations,
        language,
        "UI",
        reformatted
      )
    }

    if (array.length > 2) {
      const character1 = String.fromCharCode(hasUnicode(array[0]))
      const reformatted1 = array[0].split(character1).join(" ")
      const reformatted2 = array[array.length - 1].split(character1).join(" ")
      return `${getTranslation(
        translations,
        language,
        "UI",
        reformatted1
      )}-${getTranslation(
        translations,
        language,
        "UI",
        reformatted2
      )}`
    }

    if (
      array.includes("Post-Abraham Genealogy") ||
      array.includes("Pre-Abraham Genealogy") ||
      array.includes("Eschatos") ||
      array.includes("Pre-Abraham")
    ) {
      return array
        .map(el => {
          console.log(el.includes("reformatted"))
          const reformatted = el.split("\u202F").join(" ")
          getTranslation(translations, language, "UI", reformatted)
        })
        .join(", ")
    }
    const character1 = String.fromCharCode(hasUnicode(array[0]))
    const reformatted1 = array[0].split(character1).join(" ")
    const reformatted2 = array[1].split(character1).join(" ")
    return `${getTranslation(
      translations,
      language,
      "UI",
      reformatted1
    )}-${getTranslation(
      translations,
      language,
      "UI",
      reformatted2
    )}`
  }

  return (
    <React.Fragment>
      <div
        className={`${classes.link} ${classes.left}`}
        onClick={() => checkNavSegmentExists(currentSegmentID, "prev")}
        data-cy="navButton-prev"
      >
        <IconButton>
          <PlayCircleFilled
            className={classes.icon}
            style={{ transform: "rotate(180deg)" }}
          />
        </IconButton>
      </div>
      {currentRefLocation && (
        <div className={`${classes.currentRefContainer} ${classes.link}`}>
          <div className={classes.containerHolder}>
            {showCurrentRef && (
              <div className={classes.currentRef}>
                {currentRefLocation.translation}
              </div>
            )}
            {showTimePeriod && (
              <div className={classes.currentTimePeriod}>
                {getTimePeriodText(TimePeriod[currentRefLocation.eng])}
              </div>
            )}
          </div>
        </div>
      )}
      <div
        className={`${classes.link} ${classes.right}`}
        onClick={() => checkNavSegmentExists(currentSegmentID, "next")}
        data-cy="navButton-next"
      >
        <IconButton>
          <PlayCircleFilled className={classes.icon} />
        </IconButton>
      </div>
    </React.Fragment>
  )
})

export default IconButtons
